import { SvgIcon, type SvgIconProps } from "@mui/material";
import type React from "react";

export const InfoIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon color="primary" fontSize="small" {...props} viewBox="0 0 20 20">
            <g>
                <path d="M 7,17.5 8.49999,16 h 3 l 1.5,1.5 h -4.5 z" id="path2" />
                <path
                    d="m 11.49999,4 c 0,0.82843 -0.6716,1.5 -1.5,1.5 -0.8284,0 -1.5,-0.67157 -1.5,-1.5 0,-0.82843 0.6716,-1.5 1.5,-1.5 0.8284,0 1.5,0.67157 1.5,1.5 z m 0,13.5 h -3 v -9 h 3 z"
                    id="path4"
                />
            </g>
        </SvgIcon>
    );
};
